export default __webpack_public_path__ + "navigation-examples-embedded-navigation-thumbnail-v1-480-37720d528992e5a3482b387e6f00a041.png";